import { observer } from 'mobx-react-lite'
import { Icon, IconButton, Typography, type IIconsVector } from 'shared/ui'
import styles from './styles.module.scss'

type ICounterWithInfoProps = {
  icon: IIconsVector
  name: string
  cost: string
  counter: number
  changeCounter: (counter: number) => void
}

export const CounterWithInfo = observer(
  ({ icon, name, cost, counter, changeCounter }: ICounterWithInfoProps) => {
    return (
      <div className={styles.counterWithInfo}>
        <Icon icon={icon} fontSize={24} color='var(--content-primary-tertiary)' />

        <div className={styles.counterWithInfoName}>
          <Typography ariaLabel='counter_with_info_name' variant='body-lg-medium'>
            {name}
          </Typography>
          <Typography ariaLabel='counter_with_info_cost' variant='body-md-regular'>
            {cost}
          </Typography>
        </div>

        <div className={styles.counterWithInfoCounter}>
          <IconButton
            ariaLabel='counter_with_info_decrement'
            icon='remove'
            size='small'
            color='secondary'
            variant='contained'
            disabled={counter === 0}
            onClick={() => changeCounter(counter - 1)}
          />
          <Typography
            ariaLabel='counter_with_info_value'
            variant='body-md-regular'
            className={styles.counterWithInfoValue}
          >
            {counter}
          </Typography>
          <IconButton
            ariaLabel='counter_with_info_increment'
            icon='add'
            size='small'
            variant='contained'
            color='secondary'
            onClick={() => changeCounter(counter + 1)}
          />
        </div>
      </div>
    )
  }
)
